import { RouteRecordRaw } from 'vue-router';

let routes: RouteRecordRaw[] = [
    {
        path: '/villageConfig',
        name: 'villageConfig',
        meta: { sideMenuLabel: "Villaggi" },
        component: () => import("./views/villageConfigs.vue")
    },
    {
        path: '/villageConfig/:identifier',
        name: 'villageConfigDetail',
        component: () => import("./views/villageConfigDetail.vue")
    },
];

export default routes;